export default "__VITE_ASSET__88bbaab4__"